import React from "react";
import {useNavigate} from "react-router-dom";

function CategoryCard(props) {
    const navigate = useNavigate();

    return (
        <div id="category"
             className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden">
            <div className="h-64 overflow-hidden">
                <img
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    src={props.image}
                    alt={props.name}/>
            </div>
            <div className="p-6">
                <h3 className="text-xl font-serif font-semibold mb-2">{props.name}</h3>
                <p className="text-gray-600 mb-4">{props.description}</p>
                <button onClick={()=>{navigate(`/products`)}}
                    className="text-brand-green hover:text-light-green font-medium flex items-center group">
                    Shop Now
                    <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </button>
            </div>
        </div>
    );
}

export default CategoryCard;